import * as momentImported from 'moment';
import { IAudienceQuery } from '../interfaces/audience.query.interface';
const moment = momentImported;

// @dynamic
export class MaxBrainAudience {
    static readonly ERROR_NOT_PART_OF_SELECTED_EXPERIENCE = 'not_part_of_the_selected_experience';
    static readonly ERROR_BROKEN_AUDIENCE_FILTER = 'broken_audience_filter';

    static label_singular = 'audience';
    static label_plural = 'audiences';

    static props_to_search = ['name'];

    id: string;
    name: string;
    breadcrumbs: string | null;
    lastUpdate: momentImported.Moment;
    memberCount: number;
    emptyWidgets: number[];
    isAutoGenerated: boolean;
    type: number;
    hasEmptyWidget: boolean;
    isSelected?: boolean;
    parent: {
        id: string;
        name: string;
        lastUpdate: momentImported.Moment;
        memberCount: number;
        emptyWidgets: number[];
        isAutoGenerated: boolean;
        type: number;
        hasEmptyWidget: boolean;
        open: boolean; // Frontend property
        childrenCount: number;
        hasRelevantExperiences: boolean;
        relevantExperienceCount: number;
    };
    open: boolean; // Frontend property
    isDefault: boolean;
    childrenCount: number;
    isAlreadyLinkedAudience?: boolean;
    hasRelevantExperiences: boolean;
    relevantExperienceCount: number;
    selectable?: boolean;
    /** From `GET /engage/audiences/default` when the row has a consistency warning */
    error: string | null;
    isValid: boolean;

    constructor(query?: IAudienceQuery) {
        this.error = null;
        this.isValid = true;
        this.breadcrumbs = null;
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.breadcrumbs = query.breadcrumbs ?? null;
            this.lastUpdate = query.last_update ? moment(query.last_update) : null;
            this.memberCount = query.member_count;
            this.emptyWidgets = query.empty_widgets;
            this.isAutoGenerated = query.is_auto_generated;
            this.type = query.type;
            this.hasEmptyWidget = query.has_empty_widget;
            this.open = false;
            this.childrenCount = query.children_count;
            this.hasRelevantExperiences = query.has_relevant_experiences;
            this.relevantExperienceCount = query.relevant_experience_count;

            const { parent, empty_widgets, is_auto_generated, type, has_empty_widget, children_count } = query;

            this.parent = parent
                ? {
                      id: parent.id.toString(),
                      name: parent.name,
                      lastUpdate: parent.last_update ? moment(parent.last_update) : null,
                      memberCount: parent.member_count,
                      emptyWidgets: empty_widgets,
                      isAutoGenerated: is_auto_generated,
                      type,
                      hasEmptyWidget: has_empty_widget,
                      open: false,
                      childrenCount: children_count,
                      hasRelevantExperiences: parent.has_relevant_experiences,
                      relevantExperienceCount: parent.relevant_experience_count,
                  }
                : null;
            this.isDefault = query.is_default;
            this.selectable = query.selectable;
            this.error = query.error ?? null;
            this.isValid = query.is_valid ?? true;
        }
    }
}
